import store from '../store/index'

export default class AcademicService {
    async getAcademics() {
        const data = await store.dispatch('jv/get', ['academics', {params: {include: 'staff'}}]);
        return Object.values(data)
    }

    async createAcademic(payload) {
        return await store.dispatch('jv/post', payload)
    }

    async updateAcademic(payload) {
        return await store.dispatch('jv/patch', payload)
    }

    async deleteAcademic(id) {
        return await store.dispatch('jv/delete', `academics/${id}`)
    }

    logError(e) {
        const error = []
        if (e.response.data.errors) {
            // Work with each error from the JSONAPI 'errors' array
            for (const err of e.response.data.errors) {
                error.push(err.detail)
            }
        }
        return error
    }

    availableLevels() {
        return [
            { name: 'Certificate' },
            { name: 'Higher Certificate' },
            { name: 'Diploma' },
            { name: 'Higher Diploma' },
            { name: 'Professional Diploma' },
            { name: 'Associate Degree' },
            { name: 'Bachelor Degree' },
            { name: 'Master Degree' },
            { name: 'Doctorate Degree' },
            { name: 'Others' }
        ];
    }

    availableDisciplines() {
        return [
            { name: 'Accounting' },
            { name: 'Arbitration/Mediation' },
            { name: 'Arborist' },
            { name: 'BIM' },
            { name: 'Biology/Ecology' },
            { name: 'Building' },
            { name: 'Civil' },
            { name: 'Computer Science' },
            { name: 'Contract' },
            { name: 'Environmental' },
            { name: 'Geology/Earth Science' },
            { name: 'Geotechnical' },
            { name: 'GIS' },
            { name: 'HSE/Safety' },
            { name: 'Information Technology' },
            { name: 'Landscape' },
            { name: 'Law' },
            { name: 'Material' },
            { name: 'Mechanical' },
            { name: 'Quality Assurance' },
            { name: 'Site Supervision' },
            { name: 'Structural' },
            { name: 'Surveying' },
            { name: 'Transportation' },
            { name: 'Others' }
        ];
    }
}
